import React, {Component} from 'react';
import { getUsers, removeUser } from '../../modules/Api';
import ReactTable from 'react-table'
import history from '../../modules/History';
import { notification, DatePicker, Button } from 'antd';
import ACL from '../../components/ACL';

class Users extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            roles: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    fetchData = (query = '') => {
        getUsers(query, (data) => {
            this.setState({
                items: data.data,
                count: data.total,
                last_page: data.last_page,
                pageSize: data.per_page
            })
        });
        // getRolesList(data => this.setState({roles: data}));
    }
    onChange(state) {
        this.setState({pageSize: state.pageSize});
        // make filters
        const firstName = state.filtered.find(f => f.id === 'first_name') ? state.filtered.find(f => f.id === 'first_name').value : '';
        const lastName = state.filtered.find(f => f.id === 'last_name') ? state.filtered.find(f => f.id === 'last_name').value : '';
        const email = state.filtered.find(f => f.id ==='email') ? state.filtered.find(f => f.id ==='email').value : '';
        const role = state.filtered.find(f => f.id ==='role_id') ? state.filtered.find(f => f.id ==='role_id').value : '';
        const phone = state.filtered.find(f => f.id === 'phone') ? state.filtered.find(f => f.id === 'phone').value : '';
        const lastActivity = state.filtered.find(f => f.id === 'last_activity') ? state.filtered.find(f => f.id === 'last_activity').value : '';
        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&first_name=${firstName}&last_name=${lastName}&email=${email}&role=${role}&phone=${phone}&last_activity=${lastActivity}`;
        // commit changes
        this.fetchData(query);
    }
    removeUser(id) {
        const warningMessage = `آیا از حذف کاربر اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        if (window.confirm(warningMessage)) {
            this.fetchData();
            removeUser(id, () => {
                notification.open({
                    message: `کاربر با موفقیت حذف شد!`,
                    description: `تمامی اطلاعات کاربر با موفقیت حذف شدند.`
                })
            })
        }
    }
    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id'
            },
            {
                Header: 'نام',
                accessor: 'first_name',
                filterable: true,
                Cell: (row) => (<ACL component="span" has_permission="users_edit" denied={() => {return row.original.first_name;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.first_name} onClick={() => {window.open(`/users/edit/${row.original.id}`, "_blank")}}> {row.original.first_name} </span></ACL>)
            },
            {
                Header: 'نام خانوادگی',
                accessor: 'last_name',
                filterable: true,
                Cell: (row) => (<span title={row.original.last_name}> {row.original.last_name} </span>)
            },
            {
                Header: 'ایمیل',
                accessor: 'email',
                filterable: true,
                Cell: (row) => (<span title={row.original.email}> {row.original.email} </span>)
            },
            {
                Header: 'شماره موبایل',
                accessor: 'phone',
                filterable: true,
                Cell: (row) => (<span title={row.original.phone}> {row.original.phone} </span>)
            },
            {
                Header: 'موبایل تایید شده؟',
                accessor: 'status',
            Cell: (row) => (<span> {row.original.status === 1 ? 'بله' : 'خیر'} </span>)
            },
            {
                Header: 'نقش',
                accessor: 'role_id',
                filterable: true,
                Cell: (row) => (<span> {row.original.role} </span>)
            },
            {
                Header: 'تاریخ آخرین فعالیت',
                accessor: 'last_activity',
                filterable: true,
                Cell: (row) => (<span title={row.original.last_activity}> {row.original.last_activity} </span>),
                Filter:  ({ filter, onChange }) => <div style={{direction: 'ltr'}} >
                    <DatePicker onChange={(date, date_string) => onChange(date_string)} />
                </div>
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="users_delete"><span onClick={() => {this.removeUser(row.original.id)}} style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="users_history"><span onClick={() => history.item.push(`/history/user/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },

        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div class="btn-container">
                    <ACL component="span" has_permission="users_history"><Button type="secondary" onClick={() => history.item.push(`/history/user`)}>تاریخچه تغییرات</Button></ACL>
                </div>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default Users;


// WEBPACK FOOTER //
// ./src/containers/Users/index.js